import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import Header from './Header';
import axios from 'axios';
import GrievancePICTable from './GrievancePICTable';
import GrievanceFHRTable from './GrievanceFHRTable';
import GrievanceAdminTable from './GrievanceAdminTable';
import AddPermissionModal from './AddPermissionModal';
import "./GrievancePermission.css"; 

const GrievancePermission = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [permissionPICAll, setPermissionPICAll] = useState([]);
    const [permissionPICStaff, setPermissionPICStaff] = useState([]);
    const [permissionPICWorker, setPermissionPICWorker] = useState([]);
    const [permissionFHR, setPermissionFHR] = useState([]);
    const [permissionAdmin, setPermissionAdmin] = useState([]);

    const [addPermissionModal, setAddPermissionModal] = useState(false);
    const handleAddPermissionModal = () => setAddPermissionModal(!addPermissionModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Grievance Setting') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }
        }
    }, [props.loginList]);

    // useEffect(() => {
    //     if (props.grievancePermission) {
    //       const grievancePermissionFromParent = props.grievancePermission;
          
    //       if (grievancePermissionFromParent == 0) {
    //             window.stop();
    //             alert('You have no permissions to access this page.');
    //             window.location = '/';
    //       }
    //       else {
    //             setIsLoading(false);
    //       }
    //     }
    
    //   }, [props.grievancePermission]);

    useEffect(() => {
        const getPermissionList = async () => {
            const permissionListFromServer = await fetchPermission();
            const permissionPICAlllist = permissionListFromServer.filter(
                (permissionlist) => permissionlist.roleID == 1
            );
            const permissionFHRlist = permissionListFromServer.filter(
                (permissionlist) => permissionlist.roleID == 2
            );
            const permissionAdminlist = permissionListFromServer.filter(
                (permissionlist) => permissionlist.roleID == 3
            );
            const permissionPICStafflist = permissionListFromServer.filter(
                (permissionlist) => permissionlist.roleID == 4
            );
            const permissionPICWorkerlist = permissionListFromServer.filter(
                (permissionlist) => permissionlist.roleID == 5
            );
            setPermissionPICAll(permissionPICAlllist);
            setPermissionPICStaff(permissionPICStafflist);
            setPermissionPICWorker(permissionPICWorkerlist);
            setPermissionFHR(permissionFHRlist);
            setPermissionAdmin(permissionAdminlist);
        };

        getPermissionList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchPermission = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getpermissionlist'
        );
        const data = await res.json();

        return data.GrievanceUserPermissionList;
    };

    const addGrievancePermission = (addPermission) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/grievance/addgrievancepermission';
        const addPermissionDetails = {
            userID: addPermission.userID,
            userName: addPermission.userName,
            factory: addPermission.factorylist,
            category: addPermission.categorylist,
            roleID: addPermission.selectRole,
            createdBy: addPermission.createdBy
        };

        axios
            .post(url, addPermissionDetails)
            .then(
                (response) =>
                    alert('New role has been successfullly created!'),
                setTimeout(() => {
                    setAddPermissionModal(!addPermissionModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const PermissionPICTable = () => {
        return (
            <Fragment>
                {permissionPICAll?.length > 0 ? (
                    <GrievancePICTable permissionPIC={permissionPICAll} />
                ) : (
                    <div>No Grievance PIC (Staff & Worker) to show</div>
                )}
            </Fragment>
        );
    };

    const PermissionPICStaffTable = () => {
        return (
            <Fragment>
                {permissionPICStaff?.length > 0 ? (
                    <GrievancePICTable permissionPIC={permissionPICStaff} />
                ) : (
                    <div>No Grievance PIC (Staff) to show</div>
                )}
            </Fragment>
        );
    };

    const PermissionPICWorkerTable = () => {
        return (
            <Fragment>
                {permissionPICWorker?.length > 0 ? (
                    <GrievancePICTable permissionPIC={permissionPICWorker} />
                ) : (
                    <div>No Grievance PIC (Staff) to show</div>
                )}
            </Fragment>
        );
    };

    const PermissionFHRTable = () => {
        return (
            <Fragment>
                {permissionFHR?.length > 0 ? (
                    <GrievanceFHRTable permissionFHR={permissionFHR} />
                ) : (
                    <div>No FHR to show</div>
                )}
            </Fragment>
        );
    };

    const PermissionAdminTable = () => {
        return (
            <Fragment>
                {permissionAdmin?.length > 0 ? (
                    <GrievanceAdminTable permissionAdmin={permissionAdmin} />
                ) : (
                    <div>No admin to show</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <Header />
                        <div className='table-wrapper' id='permissionList'>
                            <p style={{ justifyContent: 'space-between', display: 'flex' }}>
                                <div>
                                    <button autofocus="true" class="btn btn-primary grievancetabletoggle" type="button" data-bs-toggle="collapse" data-bs-target="#Admincollapse" aria-expanded="false" aria-controls="Admincollapse">
                                        Admin
                                    </button>
                                    <button class="btn btn-primary grievancetabletoggle" type="button" data-bs-toggle="collapse" data-bs-target="#PICcollapse" aria-expanded="false" aria-controls="PICcollapse">
                                        Grievance PIC
                                        <br></br>
                                        (Staff & Worker)
                                    </button>
                                    <button class="btn btn-primary grievancetabletoggle" type="button" data-bs-toggle="collapse" data-bs-target="#PICStaffcollapse" aria-expanded="false" aria-controls="PICStaffcollapse">
                                        Grievance PIC
                                        <br></br>
                                        (Staff)
                                    </button>
                                    <button class="btn btn-primary grievancetabletoggle" type="button" data-bs-toggle="collapse" data-bs-target="#PICWorkercollapse" aria-expanded="false" aria-controls="PICWorkercollapse">
                                        Grievance PIC
                                        <br></br>
                                        (Worker)
                                    </button>
                                    <button class="btn btn-primary grievancetabletoggle" type="button" data-bs-toggle="collapse" data-bs-target="#FHRcollapse" aria-expanded="false" aria-controls="FHRcollapse">
                                        FHR
                                    </button>
                                </div>
                                <div>
                                    <button className='btn btn-primary grievancetabletoggle' type="button" onClick={handleAddPermissionModal}>Create New</button>
                                    <AddPermissionModal
                                        show={addPermissionModal}
                                        handleClose={handleAddPermissionModal}
                                        onAdd={addGrievancePermission}
                                    />
                                </div>
                            </p>

                            <div class="accordion-group">
                                <div class="collapse show" id="Admincollapse" data-bs-parent="#permissionList">
                                    <div class="card card-body">
                                        <PermissionAdminTable />
                                    </div>
                                </div>
                                <div class="collapse" id="PICcollapse" data-bs-parent="#permissionList">
                                    <div class="card card-body">
                                        <PermissionPICTable />
                                    </div>
                                </div>
                                <div class="collapse" id="PICStaffcollapse" data-bs-parent="#permissionList">
                                    <div class="card card-body">
                                        <PermissionPICStaffTable />
                                    </div>
                                </div>
                                <div class="collapse" id="PICWorkercollapse" data-bs-parent="#permissionList">
                                    <div class="card card-body">
                                        <PermissionPICWorkerTable />
                                    </div>
                                </div>
                                <div class="collapse" id="FHRcollapse" data-bs-parent="#permissionList">
                                    <div class="card card-body">
                                        <PermissionFHRTable />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default GrievancePermission;